module.exports = __webpack_public_path__ + "static/media/right-arrow.eb01ed34.svg";